import script from "./StatBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./StatBarChart.vue?vue&type=script&setup=true&lang=js"

import "./StatBarChart.vue?vue&type=style&index=0&id=22585335&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22585335"]])

export default __exports__